import React from 'react';
import { PopupContainer, PopupHeader, PopupBody, PopupActions, PopupButton } from './ErrorPopup.Styled';
import { Grid, Typography } from '@mui/material';
import { ExitIcon } from '../../assets/images/UI-dashboard';

interface ErrorPopupProps {
  open: boolean;
  message: string;
  onClose: () => void;
  title?: string;
}

const ErrorPopup: React.FC<ErrorPopupProps> = ({ open, message, onClose, title = 'Error' }) => {
  if (!open) return null;

  return (
    <PopupContainer>
      <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
        <PopupHeader>{title}</PopupHeader>
        <Grid
          style={{
            border: '1px solid black',
            borderRadius: '50%',
            width: '30px',
            height: '30px',
            display: 'flex',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <img
            style={{
              opacity: '100%%',
              width: '10px',
            }}
            onClick={onClose}
            src={ExitIcon}
            alt="Exit"
          />
        </Grid>
      </Grid>
      <PopupBody>{message}</PopupBody>
      <PopupActions>
        <PopupButton style={{ color: 'white', background: '#df2020' }} variant="contained" onClick={onClose}>
          <Typography
            style={{
              fontWeight: 'bold',
              fontSize: '15px',
              color: 'white',
            }}
          >
            Okay
          </Typography>
        </PopupButton>
      </PopupActions>
    </PopupContainer>
  );
};

export default ErrorPopup;
